/** @jsx jsx */

import React, { useMemo } from "react";
import { Row, Col, Typography } from "antd";
import { jsx } from "@emotion/core";
import { useLocation } from "react-router-dom";

import EligibilityCard from "./EligibilityCard";
import StatusCard from "./StatusCard";
import BillsCard from "./BillsCard";
import MyInfoCard from "./MyInfoCard";
import DisbursalAccountDetailsCard from "./AccountDetailsCard";
import useLoanStatus from "../../hooks/auth/useLoanStatus";
import useNameAndImage from "../../hooks/profile/useNameAndImage";

import { routes } from "../../Routes";
import { homeStyles } from "./HomeStyles";
import { homeContents as CONSTANTS } from "./HomeConstants";

const { Text } = Typography;

const Home: React.FC = () => {
  const { showDisbursalAccountDetailsCard } = useLoanStatus();
  const { userName } = useNameAndImage();
  const location = useLocation();

  const preventDataFetch: boolean = useMemo(() => {
    return location?.pathname === routes.home.initializeEligibility;
  }, [location]);

  return (
    <div css={homeStyles} className="mt-4">
      <Text className="greeting d-block mb-4">
        {CONSTANTS.labels.greeting(userName)}
      </Text>
      <Row gutter={[16, 16]} className="mt-2">
        <Col sm={24} md={13}>
          <EligibilityCard />
        </Col>
        <Col sm={24} md={11}>
          <StatusCard preventDataFetch={preventDataFetch} />
        </Col>
        <Col sm={24} md={13}>
          <BillsCard preventDataFetch={preventDataFetch} />
        </Col>
        <Col sm={24} md={11}>
          {showDisbursalAccountDetailsCard ? (
            <DisbursalAccountDetailsCard />
          ) : (
            <MyInfoCard preventDataFetch={preventDataFetch} />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Home;
